import { getUrlMatches } from 'core-components/helpers/getUrlMathces'
import { YOUTUBE_REG_EXPS } from 'core-components/library/richTextEditor/constants'

export const getYoutubeUrl = ({ url, startTime }: { url: string; startTime?: number }) => {
  const match = getYoutubeUrlMatch(url)
  if (match) {
    const id = match[1]
    const tParamValue = getParamFromUrl(url, 't')
    const startTimeFromUrl = tParamValue ? parseInt(tParamValue, 10) : null
    return calcYoutubeUrl(id, startTime || startTimeFromUrl)
  }
  return ''
}

const getYoutubeUrlMatch = (url: string) => {
  for (const exp of YOUTUBE_REG_EXPS) {
    const match = getUrlMatches(url, exp)
    if (match) {
      return match
    }
  }
  return null
}

const getParamFromUrl = (url: string, paramName: string) => {
  const params = url.split('?')[1] || ''
  const urlSearchParams = new URLSearchParams(params)
  return urlSearchParams.get(paramName)
}

const calcYoutubeUrl = (id: string, startTime: number | null) => {
  const youtubeUrl = `https://www.youtube.com/embed/${id}`
  if (startTime) {
    return `${youtubeUrl}?start=${startTime}`
  }
  return youtubeUrl
}
